(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3454,1692,7938],{

/***/ 47180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89093);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5434);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1692);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3095);
/* harmony import */ var _page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);

var _excluded = ["data", "pageType", "id", "authorName", "authorImage"];

/* eslint-disable @next/next/no-img-element */












var PageInfo = function PageInfo(_ref) {
  var _data$publishDate, _data$totalView, _data$comments;

  var data = _ref.data,
      pageType = _ref.pageType,
      id = _ref.id,
      authorName = _ref.authorName,
      authorImage = _ref.authorImage,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref, _excluded);

  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_1__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_2__/* .authAtom */ .L4);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
    className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().short_info),
    children: [data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().author), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
          src: authorImage || "/favicon.jpg",
          alt: authorName || "author",
          width: 30,
          height: 30
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: authorName
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Author"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.publishDate) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().date), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdCalendarToday */ .kVv, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: moment__WEBPACK_IMPORTED_MODULE_3___default()((_data$publishDate = data.publishDate) !== null && _data$publishDate !== void 0 ? _data$publishDate : new Date()).format("MMM DD, YYYY")
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Date Published "
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.totalView) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().view), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdRemoveRedEye */ .FpO, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (_data$totalView = data.totalView) !== null && _data$totalView !== void 0 ? _data$totalView : ""
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Views"
        })]
      })]
    }), data && (data === null || data === void 0 ? void 0 : data.comments) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "".concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().comment), " ").concat((_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info_item)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().icon),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_10__/* .MdForum */ .Rlc, {})
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().text),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().name),
          children: (data === null || data === void 0 ? void 0 : (_data$comments = data.comments) === null || _data$comments === void 0 ? void 0 : _data$comments.length) || 0
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
          className: (_page_info_module_scss__WEBPACK_IMPORTED_MODULE_9___default().desc),
          children: "Comments"
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common_ui_element_actions_bookmark__WEBPACK_IMPORTED_MODULE_5__["default"], {
      referance: pageType,
      referanceId: id ? parseInt(id) : "",
      is_bookmarked: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .isReadingListed */ .uO)(profileInfo, pageType, id)
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PageInfo);

/***/ }),

/***/ 42422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ PlayButtonWithRipple; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30890);
/* harmony import */ var _play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["colorOrange", "medium", "ripple", "small"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PlayButtonWithRipple = function PlayButtonWithRipple(_ref) {
  var colorOrange = _ref.colorOrange,
      medium = _ref.medium,
      _ref$ripple = _ref.ripple,
      ripple = _ref$ripple === void 0 ? true : _ref$ripple,
      small = _ref.small,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", _objectSpread(_objectSpread({
    className: "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play_btn), " ").concat(colorOrange ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().orange)) : "", " ").concat(medium ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().medium)) : "", " ").concat(small ? "".concat((_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().small)) : "")
  }, props), {}, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow_right)
    }), ripple && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_play_btn_with_ripple_module_scss__WEBPACK_IMPORTED_MODULE_4___default().ripple_effect)
    })]
  }));
};
/* harmony default export */ __webpack_exports__["Z"] = (PlayButtonWithRipple);

/***/ }),

/***/ 83380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialSharingLinks": function() { return /* binding */ SocialSharingLinks; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var next_share__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21818);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89583);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86893);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76300);
/* harmony import */ var _social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["url", "title", "hashtag"];






var SocialSharingLinks = function SocialSharingLinks(_ref) {
  var url = _ref.url,
      title = _ref.title,
      hashtag = _ref.hashtag,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
    className: "".concat((_social_links_module_scss__WEBPACK_IMPORTED_MODULE_3___default().social_links_wrapper), " ").concat(props.className),
    style: props.style,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .FacebookShareButton */ .Dk, {
      url: url,
      quote: title,
      hashtag: hashtag,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiFacebook */ .Bsb, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .TwitterShareButton */ .B, {
      url: url,
      title: title,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiTwitter */ .Ccr, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .LinkedinShareButton */ .r2, {
      url: url,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_4__/* .FiLinkedin */ .qOw, {})
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_share__WEBPACK_IMPORTED_MODULE_0__/* .WhatsappShareButton */ .N0, {
      url: url,
      title: title,
      separator: ":: ",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaWhatsapp */ .xpo, {})
    })]
  });
};
/* harmony default export */ __webpack_exports__["default"] = (SocialSharingLinks);

/***/ }),

/***/ 47445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyBanner": function() { return /* binding */ StudyBanner; }
/* harmony export */ });
/* harmony import */ var _unisearch_common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74155);
/* harmony import */ var _unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56753);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90705);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common_page_info__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47180);
/* harmony import */ var _study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58982);
/* harmony import */ var _study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
/* eslint-disable @next/next/no-img-element */










var StudyBanner = function StudyBanner(_ref) {
  var _pageData$guidepdf, _pageData$guidepdf2, _pageData$featureImag, _pageData$featureImag2;

  var pageData = _ref.pageData,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      linkType = _ref.linkType;
  var arr = ["united-states", "united-kingdom"];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("section", {
    className: "".concat((_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().section_study_banner), " !pt-6"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        className: "lg:mb-[60px]"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
        className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hero_wrapper),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().hero_content),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("p", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().sub_heading),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
              className: "bold",
              children: pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName
            }), " ", (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .readingTime */ .f6)(pageData.pageContent) || 1, " ", "min read"]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("h1", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().heading),
            children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
          }), (pageData === null || pageData === void 0 ? void 0 : pageData.pageShortDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().description),
            children: (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .remove_tags */ .AK)(pageData.pageShortDescription)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().breadcrumbs),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              legacyBehavior: true,
              href: "/",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("span", {
                  children: "Home"
                })
              })
            }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
              legacyBehavior: true,
              href: "/".concat(linkType, "/").concat(name),
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", {
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("span", {
                  children: [linkType, " ", linkType === "study" ? "in ".concat(arr.includes(name) ? "the" : "") : "", " ", pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName]
                })
              })
            }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("p", {
              className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active),
              children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().short_info_desktop_),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_common_page_info__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              pageType: "page",
              id: pageData === null || pageData === void 0 ? void 0 : pageData.pageId,
              data: pageData,
              authorName: pageData === null || pageData === void 0 ? void 0 : pageData.authorName,
              authorImage: pageData === null || pageData === void 0 ? void 0 : pageData.authorProfileImage
            })
          }), pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.guidepdf) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button_wrapper),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_unisearch_common__WEBPACK_IMPORTED_MODULE_0__/* .DownloadGuide */ .E6, {
              customClasses: {
                root: "btn-bg"
              },
              fileSrc: pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf = pageData.guidepdf) === null || _pageData$guidepdf === void 0 ? void 0 : _pageData$guidepdf.src,
              documentId: parseInt(pageData === null || pageData === void 0 ? void 0 : (_pageData$guidepdf2 = pageData.guidepdf) === null || _pageData$guidepdf2 === void 0 ? void 0 : _pageData$guidepdf2.mediaManagerId),
              documentType: linkType == "study" ? "countryguide" : linkType
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
          className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().image_wrapper),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            layout: "responsive",
            width: 500,
            height: 450,
            blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
            placeholder: "blur",
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().featured_image),
            src: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag = pageData.featureImage) === null || _pageData$featureImag === void 0 ? void 0 : _pageData$featureImag.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/country_placeholder.webp"),
            alt: pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag2 = pageData.featureImage) === null || _pageData$featureImag2 === void 0 ? void 0 : _pageData$featureImag2.alt
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().bg_soft)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
            className: (_study_banner_module_scss__WEBPACK_IMPORTED_MODULE_8___default().oval_square),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
              width: 150,
              height: 150,
              src: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .getAssets */ .Vh)("assets/images/study/ornament.webp"),
              alt: "Ornament"
            })
          })]
        })]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyBanner);

/***/ }),

/***/ 78589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyBannerTwo": function() { return /* binding */ StudyBannerTwo; }
/* harmony export */ });
/* harmony import */ var _unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56753);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90705);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _common_page_info__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47180);
/* harmony import */ var _study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42817);
/* harmony import */ var _study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









var StudyBannerTwo = function StudyBannerTwo(_ref) {
  var pageData = _ref.pageData,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      linkType = _ref.linkType;
  var arr = ["united-states", "united-kingdom"];
  var link = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  var asPath = link.asPath;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
    className: "".concat((_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_study_banner), " !pt-7"),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_unisearch_common_google_ad_top__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
        className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hero_container),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("p", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sub_heading),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
            className: "bold",
            children: pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName
          }), " ", (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .readingTime */ .f6)(pageData.pageContent) || 1, " ", "min read"]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("h1", {
          className: "heading-one",
          children: pageData.pageTitle
        }), (pageData === null || pageData === void 0 ? void 0 : pageData.pageShortDescription) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
          children: (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .remove_tags */ .AK)(pageData.pageShortDescription)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().breadcrumbs),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            legacyBehavior: true,
            href: "/",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("span", {
                children: "Home"
              })
            })
          }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            legacyBehavior: true,
            href: "/".concat(linkType, "/").concat(name),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("a", {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("span", {
                children: [linkType, " ", linkType === "study" ? "in ".concat(arr.includes(name) ? "the" : "") : "", " ", pageData === null || pageData === void 0 ? void 0 : pageData.referenceColumnName]
              })
            })
          }), " - ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
            className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active),
            children: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle
          })]
        }), asPath !== "/".concat(linkType, "/").concat(name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
            className: (_study_banner_two_module_scss__WEBPACK_IMPORTED_MODULE_6___default().short_info_desktop),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_common_page_info__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              data: pageData
            })
          })
        })]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyBannerTwo);

/***/ }),

/***/ 96512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ StudyLinks; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83380);
/* harmony import */ var _study_links_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52885);
/* harmony import */ var _study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);




var baseUrl = "https://myunisearch.com";




var StudyLinks = function StudyLinks(_ref) {
  var _pageData$pageMenuGro;

  var pageData = _ref.pageData,
      name = _ref.name,
      linkType = _ref.linkType;
  var link = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var asPath = link.asPath,
      query = link.query;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("section", {
      className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().section_links),
      children: [asPath === "/study/".concat(name) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_3__["default"], {
        url: "".concat(baseUrl, "/").concat(linkType, "/").concat(name, "/").concat(pageData === null || pageData === void 0 ? void 0 : pageData.slug),
        title: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle,
        className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().social_link_wrapper)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
          className: "container",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links_container),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("ul", {
              children: pageData === null || pageData === void 0 ? void 0 : (_pageData$pageMenuGro = pageData.pageMenuGroup) === null || _pageData$pageMenuGro === void 0 ? void 0 : _pageData$pageMenuGro.map(function (menu, i) {
                var pageSlug = menu.pageSlug === menu.referenceColumnName ? name : "".concat(name, "/").concat(menu.pageSlug);
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    legacyBehavior: true,
                    href: "/".concat(linkType, "/").concat(pageSlug),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("a", {
                      className: "".concat(asPath === "/".concat(linkType, "/").concat(pageSlug) ? "".concat((_study_links_module_scss__WEBPACK_IMPORTED_MODULE_5___default().active)) : ""),
                      children: menu === null || menu === void 0 ? void 0 : menu.pageTitle
                    })
                  })
                }, i);
              })
            })
          })
        })
      })]
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (StudyLinks)));

/***/ }),

/***/ 40768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyVideo": function() { return /* binding */ StudyVideo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42422);
/* harmony import */ var _study_video_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25850);
/* harmony import */ var _study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72145);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


var ModalVideo = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 6635).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});






var StudyVideo = function StudyVideo(props) {
  var _pageData$featureImag, _pageData$featureImag2;

  var pageData = props.pageData;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      videoSrc = _useState2[0],
      setVideoSrc = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      videoType = _useState3[0],
      setVideoType = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      embededCode = _useState4[0],
      setEmbededCode = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if ((pageData === null || pageData === void 0 ? void 0 : pageData.videoType) === "upload") {
      var _pageData$videoupload;

      setVideoSrc(pageData === null || pageData === void 0 ? void 0 : (_pageData$videoupload = pageData.videoupload) === null || _pageData$videoupload === void 0 ? void 0 : _pageData$videoupload.src);
      setVideoType("custom");
      setEmbededCode("");
    } else {
      setVideoSrc("");
      setVideoType("youtube");
      setEmbededCode(pageData === null || pageData === void 0 ? void 0 : pageData.embedCode);
    }
  }, [pageData === null || pageData === void 0 ? void 0 : pageData.videoType]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("section", {
    className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().section_study_video),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("div", {
        className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().study_video_wrapper),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
          className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video_area),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_4___default()), {
            layout: "responsive",
            width: 850,
            height: 450,
            blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
            placeholder: "blur",
            className: (_study_video_module_scss__WEBPACK_IMPORTED_MODULE_6___default().featured_image),
            src: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag = pageData.featureImage) === null || _pageData$featureImag === void 0 ? void 0 : _pageData$featureImag.src) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_3__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
            alt: (pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag2 = pageData.featureImage) === null || _pageData$featureImag2 === void 0 ? void 0 : _pageData$featureImag2.alt) || "Feature Image"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_modules_study_common_play_btn_with_ripple__WEBPACK_IMPORTED_MODULE_2__/* .PlayButtonWithRipple */ .s, {
            onClick: function onClick() {
              return setOpen(true);
            }
          }), videoType === "custom" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ModalVideo, {
            channel: videoType,
            autoplay: true,
            isOpen: isOpen // videoId={`${pageData?.embedCode}`}
            ,
            url: videoSrc // url={}
            ,
            onClose: function onClose() {
              return setOpen(false);
            }
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(ModalVideo, {
            channel: videoType,
            autoplay: true,
            isOpen: isOpen // videoId={`${pageData?.embedCode}`}
            ,
            videoId: embededCode // url={}
            ,
            onClose: function onClose() {
              return setOpen(false);
            }
          })]
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyVideo);

/***/ }),

/***/ 27991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T$": function() { return /* reexport safe */ _study_banner_two__WEBPACK_IMPORTED_MODULE_0__.StudyBannerTwo; },
/* harmony export */   "aF": function() { return /* reexport safe */ _study_links__WEBPACK_IMPORTED_MODULE_3__.a; },
/* harmony export */   "dq": function() { return /* reexport safe */ _study_why_country_intro__WEBPACK_IMPORTED_MODULE_4__.StudyWhyCountryIntro; },
/* harmony export */   "hk": function() { return /* reexport safe */ _study_banner__WEBPACK_IMPORTED_MODULE_1__.StudyBanner; },
/* harmony export */   "mp": function() { return /* reexport safe */ _study_video__WEBPACK_IMPORTED_MODULE_2__.StudyVideo; }
/* harmony export */ });
/* harmony import */ var _study_banner_two__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78589);
/* harmony import */ var _study_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47445);
/* harmony import */ var _study_video__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40768);
/* harmony import */ var _study_links__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96512);
/* harmony import */ var _study_why_country_intro__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16251);






/***/ }),

/***/ 16251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StudyWhyCountryIntro": function() { return /* binding */ StudyWhyCountryIntro; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83380);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var _unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90705);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27442);
/* harmony import */ var _study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var LeadForm = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 57208));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(57208)];
    }
  }
});
var UniComment = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(2112), __webpack_require__.e(9636)]).then(__webpack_require__.bind(__webpack_require__, 32112));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(32112)];
    }
  }
});
var baseUrl = "https://myunisearch.com";
var StudyWhyCountryIntro = function StudyWhyCountryIntro(_ref) {
  var _pageData$pageContent;

  var pageData = _ref.pageData,
      name = _ref.name,
      linkType = _ref.linkType;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(),
      formData = _useState[0],
      setFormData = _useState[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var res;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("public/lead-contact-form/pages/popup");

            case 2:
              res = _context.sent;

              if (res && !res.error) {
                setFormData(res.data);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function () {
    fetchData();
  }, []);

  var LeadFormComponent = function LeadFormComponent(_ref3) {
    var className = _ref3.className;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
      children: formData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "lead_form_insidepage_wrapper ".concat(className !== null && className !== void 0 && className.root ? className === null || className === void 0 ? void 0 : className.root : ""),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "lead_form_insidepage_heading_wrapper",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("h3", {
            className: "",
            children: ["Want to study abroad? Sign up with", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
              className: "color-orange",
              children: "UniSearch!"
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "",
            children: "Jumpstart your study abroad dreams with UniSearch"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LeadForm, {
          showTitle: false,
          showSubTitle: false,
          pageData: formData,
          buttonTitle: "Submit",
          pageSlug: formData === null || formData === void 0 ? void 0 : formData.slug
        })]
      })
    });
  };

  var contentFirst;
  var contentLast;
  var isShortCodeFormExist = pageData && (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && (pageData === null || pageData === void 0 ? void 0 : (_pageData$pageContent = pageData.pageContent) === null || _pageData$pageContent === void 0 ? void 0 : _pageData$pageContent.includes("[shortcode_form]"));

  if (isShortCodeFormExist) {
    var text = pageData === null || pageData === void 0 ? void 0 : pageData.pageContent.split("[shortcode_form]");
    contentFirst = text[0];
    contentLast = text[1];
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("section", {
    className: (_study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8___default().section_intro),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "flex lg:flex-row flex-col gap-7 max-w-[900px] mx-auto w-full",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "flex gap-7",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "".concat((_study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8___default().social_wrapper), " sticky top-[170px]"),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_modules_study_common_social_sharing_links__WEBPACK_IMPORTED_MODULE_1__["default"], {
              url: "".concat(baseUrl, "/").concat(linkType, "/").concat(name, "/").concat(pageData === null || pageData === void 0 ? void 0 : pageData.slug),
              title: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle,
              className: (_study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8___default().social_link_wrapper)
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            children: (pageData === null || pageData === void 0 ? void 0 : pageData.pageContent) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "from_texteditor_wrapper",
                children: isShortCodeFormExist ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                    children: [(0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .htmlParse */ .QA)(contentFirst), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LeadFormComponent, {
                      className: {
                        root: "!my-8"
                      }
                    }), (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .htmlParse */ .QA)(contentLast)]
                  })
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
                  children: (0,_unisearch_helpers_utils__WEBPACK_IMPORTED_MODULE_3__/* .htmlParse */ .QA)(pageData === null || pageData === void 0 ? void 0 : pageData.pageContent)
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(LeadFormComponent, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
                  async: true,
                  src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
                  crossorigin: "anonymous"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ins", {
                  "class": "adsbygoogle",
                  style: {
                    display: "block"
                  },
                  "data-ad-format": "autorelaxed",
                  "data-ad-client": "ca-pub-1690314786863972",
                  "data-ad-slot": "5945244324"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("script", {
                  children: "(adsbygoogle = window.adsbygoogle || []).push({});"
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: (_study_why_country_intro_module_scss__WEBPACK_IMPORTED_MODULE_8___default().uni_comment),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(UniComment, {
                  commentType: "page",
                  referenceId: pageData === null || pageData === void 0 ? void 0 : pageData.pageId
                })
              })]
            })
          })]
        })
      })
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (StudyWhyCountryIntro);

/***/ }),

/***/ 56753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14418);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var GoogleAdTop = function GoogleAdTop(_ref) {
  var className = _ref.className;

  var _useWindowDimensions = (0,_hooks_useWindowDimensions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
      width = _useWindowDimensions.width;

  var showGoogleAdScriptTop = function showGoogleAdScriptTop() {
    if (width > 0 && width < 640) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "450px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "8403655196"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 640 && width < 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "720px",
            height: "90px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "2900310407"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    } else if (width > 1024) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          async: true,
          src: "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-1690314786863972",
          crossorigin: "anonymous"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ins", {
          className: "adsbygoogle",
          style: {
            display: "inline-block",
            width: "1000px",
            height: "250px"
          },
          "data-ad-client": "ca-pub-1690314786863972",
          "data-ad-slot": "9661445287"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("script", {
          children: "(adsbygoogle = window.adsbygoogle || []).push({});"
        })]
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "flex justify-center mx-auto mb-5 ".concat(className ? className : ""),
    children: showGoogleAdScriptTop()
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GoogleAdTop);

/***/ }),

/***/ 74155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E6": function() { return /* reexport */ DownloadGuide; },
  "qq": function() { return /* reexport */ MessageComponent; },
  "Dk": function() { return /* reexport */ PersonList; },
  "sk": function() { return /* reexport */ common_form/* UniEditorSmall */.sk; },
  "z9": function() { return /* reexport */ useIsMount; }
});

// UNUSED EXPORTS: DatePickerComponent, DateRangeComponent, Dropdown, Editor, ImageInput, MultipleFileInput, PersonProfile, TimePeriod, Title, UniEditor, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/title.jsx




var Title = function Title(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.heading,
    children: [title && /*#__PURE__*/_jsx("h3", {
      children: title
    }), subtitle && /*#__PURE__*/_jsx("p", {
      children: subtitle
    })]
  });
};
/* harmony default export */ var title = ((/* unused pure expression or super */ null && (Title)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/dropdown.jsx


var _excluded = (/* unused pure expression or super */ null && (["topLabel", "bottomLabel", "options", "placeholder", "className", "selectedValue", "inputId", "onChange", "register"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var Dropdown = function Dropdown(_ref) {
  var topLabel = _ref.topLabel,
      bottomLabel = _ref.bottomLabel,
      options = _ref.options,
      placeholder = _ref.placeholder,
      className = _ref.className,
      selectedValue = _ref.selectedValue,
      inputId = _ref.inputId,
      _onChange = _ref.onChange,
      register = _ref.register,
      rest = _objectWithoutProperties(_ref, _excluded);

  // const [value, setValue] = useState("");
  // useEffect(() => {
  //   setValue(selectedValue);
  // }, [selectedValue]);
  // const handleChange = (e) => {
  //   const { label, value } = e;
  //   setValue(value);
  //   if (onChange) {
  //     onChange(e);
  //   }
  // };
  var customStyles = {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, _defineProperty({
        height: "50px",
        boxShadow: " 0px 2px 5px rgba(38, 51, 77, 0.03)",
        borderColor: "none",
        "&:hover": {
          borderColor: "none"
        }
      }, "borderColor", state.isFocused ? "#e0e0e0" : "#e0e0e0"));
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        cursor: "pointer",
        color: state.isSelected ? "#F47F20" : "#B5B5C3",
        backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
        "&:hover": {
          backgroundColor: "#F5F6FC",
          color: "#F47F20"
        }
      });
    },
    menuPortal: function menuPortal(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        zIndex: 9999
      });
    }
  };
  return /*#__PURE__*/_jsxs(FormControl, {
    fullWidth: true,
    children: [topLabel && /*#__PURE__*/_jsx("label", {
      className: topLabel === "transparent" && styles.transparent,
      children: topLabel
    }), /*#__PURE__*/_jsx(Select, _defineProperty({
      className: "".concat(styles.select_input, " ").concat(className),
      options: options,
      onChange: _onChange,
      placeholder: placeholder && placeholder,
      styles: customStyles
    }, "onChange", function onChange(val) {
      return _onChange(val.value);
    })), bottomLabel && /*#__PURE__*/_jsx("label", {
      children: bottomLabel
    })]
  });
};
/* harmony default export */ var dropdown = ((/* unused pure expression or super */ null && (Dropdown)));
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/useIsMount.jsx

var useIsMount = function useIsMount() {
  var isMountRef = (0,react.useRef)(true);
  (0,react.useEffect)(function () {
    isMountRef.current = false;
  }, []);
  return isMountRef.current;
};
;// CONCATENATED MODULE: ./_unisearch/common/ui_element/index.js



// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton_IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(77745);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(95398);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CardHeader/CardHeader.js + 1 modules
var CardHeader = __webpack_require__(59742);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/DialogActions/DialogActions.js + 1 modules
var DialogActions = __webpack_require__(76779);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment_moment);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/cg/index.esm.js
var cg_index_esm = __webpack_require__(80471);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./node_modules/react-timeago/es6/index.js
var es6 = __webpack_require__(92042);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/person_list/list.module.scss
var list_module = __webpack_require__(6867);
var list_module_default = /*#__PURE__*/__webpack_require__.n(list_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_list/index.jsx



/* eslint-disable @next/next/no-img-element */

















var PersonList = function PersonList(_ref) {
  var _connectedUserList$so;

  var data = _ref.data,
      clickHandler = _ref.clickHandler,
      chatId = _ref.chatId,
      setCurrentChat = _ref.setCurrentChat,
      socket = _ref.socket,
      connectedUserList = _ref.connectedUserList,
      getConnectedUserList = _ref.getConnectedUserList,
      loading = _ref.loading,
      setLoading = _ref.setLoading,
      customClasses = _ref.customClasses,
      closeDrawer = _ref.closeDrawer;

  var _useState = (0,react.useState)(),
      activeProfile = _useState[0],
      setActiveProfile = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      userList = _useState3[0],
      setUserList = _useState3[1];

  var router = (0,next_router.useRouter)(); // open chat box

  var handleClick = function handleClick(person) {
    if (clickHandler) clickHandler(person);
  };

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  }; // get university list to add into friend list


  var getUserList = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(keyword) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (keyword && keyword.length >= 2 && keyword != "") {
                setLoading(true);
                setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return api/* default.get */.Z.get("/chat-service/get-users/".concat(keyword)).then(function (res) {
                            if (!res.error) {
                              setUserList(res.data);
                              setLoading(false);
                            }
                          });

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 2000);
              }

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getUserList(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); // add user into chat list


  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(payload) {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return api/* default.post */.Z.post("/chat-service/add-user", {
                recieverId: parseInt((payload === null || payload === void 0 ? void 0 : payload.userTypeSlug) === "mentor" ? payload === null || payload === void 0 ? void 0 : payload.id : payload === null || payload === void 0 ? void 0 : payload.universityId),
                recieverType: payload === null || payload === void 0 ? void 0 : payload.userTypeSlug,
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(res) {
                  var _res$data;

                  return regenerator_default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (res.error) {
                            _context3.next = 7;
                            break;
                          }

                          handleClose();
                          _context3.next = 4;
                          return getConnectedUserList();

                        case 4:
                          setUserList([]);
                          setActiveProfile();
                          router.push("/app/student/messages?chatId=".concat((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.uid));

                        case 7:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleSubmit(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat((list_module_default()).list_wrapper, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (list_module_default()).header_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "btn btn-sm btn-outline-grey ".concat((list_module_default()).btn_add_user),
          onClick: handleOpen,
          children: "New User"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Close/* default */.Z, {
          className: (list_module_default()).btn_close,
          onClick: closeDrawer
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(IconButton_IconButton/* default */.Z, {
          onClick: handleOpen,
          className: "".concat((list_module_default()).btn_plus, " relative"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "uni-tooltip",
            children: "New User"
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (list_module_default()).chatt_box_wrapper,
        children: connectedUserList && (connectedUserList === null || connectedUserList === void 0 ? void 0 : connectedUserList.length) > 0 && (connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$so = connectedUserList.sort(function (a, b) {
          var _b$recentMsg, _b$recentMsg$chat_ser, _a$recentMsg;

          return b === null || b === void 0 ? void 0 : (_b$recentMsg = b.recentMsg) === null || _b$recentMsg === void 0 ? void 0 : (_b$recentMsg$chat_ser = _b$recentMsg.chat_service_message_senderTime) === null || _b$recentMsg$chat_ser === void 0 ? void 0 : _b$recentMsg$chat_ser.localeCompare(a === null || a === void 0 ? void 0 : (_a$recentMsg = a.recentMsg) === null || _a$recentMsg === void 0 ? void 0 : _a$recentMsg.chat_service_message_senderTime);
        })) === null || _connectedUserList$so === void 0 ? void 0 : _connectedUserList$so.map(function (item, index) {
          var _item$receiver, _item$receiver$name, _item$receiver2, _item$receiver3, _item$receiver4, _item$receiver5, _item$receiver6, _item$recentMsg, _item$recentMsg2, _item$recentMsg3;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              handleClick(item);
              setCurrentChat(item === null || item === void 0 ? void 0 : item.receiver);
              setActiveProfile(item);

              if (closeDrawer) {
                closeDrawer();
              }
            },
            className: item && (item === null || item === void 0 ? void 0 : item.uid) == chatId ? (list_module_default()).active_chatt_box : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  style: (item === null || item === void 0 ? void 0 : (_item$receiver = item.receiver) === null || _item$receiver === void 0 ? void 0 : _item$receiver.userTypeSlug) === "university" ? {
                    objectFit: "contain"
                  } : {},
                  alt: (_item$receiver$name = item === null || item === void 0 ? void 0 : (_item$receiver2 = item.receiver) === null || _item$receiver2 === void 0 ? void 0 : _item$receiver2.name) !== null && _item$receiver$name !== void 0 ? _item$receiver$name : "",
                  src: item !== null && item !== void 0 && (_item$receiver3 = item.receiver) !== null && _item$receiver3 !== void 0 && _item$receiver3.media ? (item === null || item === void 0 ? void 0 : (_item$receiver4 = item.receiver) === null || _item$receiver4 === void 0 ? void 0 : _item$receiver4.media) === null ? (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png") : item === null || item === void 0 ? void 0 : (_item$receiver5 = item.receiver) === null || _item$receiver5 === void 0 ? void 0 : _item$receiver5.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: (list_module_default()).chatt_msg,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    children: item === null || item === void 0 ? void 0 : (_item$receiver6 = item.receiver) === null || _item$receiver6 === void 0 ? void 0 : _item$receiver6.name
                  }), item !== null && item !== void 0 && item.recentMsg ? /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: item === null || item === void 0 ? void 0 : (_item$recentMsg = item.recentMsg) === null || _item$recentMsg === void 0 ? void 0 : _item$recentMsg.chat_service_message_messages
                  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    children: "You Are Connected"
                  })]
                }), (item === null || item === void 0 ? void 0 : (_item$recentMsg2 = item.recentMsg) === null || _item$recentMsg2 === void 0 ? void 0 : _item$recentMsg2.chat_service_message_createdAt) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (list_module_default()).time,
                  children: moment_default()(item === null || item === void 0 ? void 0 : (_item$recentMsg3 = item.recentMsg) === null || _item$recentMsg3 === void 0 ? void 0 : _item$recentMsg3.chat_service_message_senderTime).fromNow()
                })]
              })]
            })
          }, "plist_".concat(index, "_").concat(item.id));
        }))
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
      open: open,
      onClose: handleClose,
      sx: {
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "600px",
            paddingRight: "2px"
          }
        }
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DialogTitle/* default */.Z, {
        children: ["Start a New Chat", /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
          "aria-label": "close",
          onClick: handleClose,
          sx: {
            position: "absolute",
            right: 8,
            top: 12,
            color: function color(theme) {
              return theme.palette.grey[500];
            }
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(cg_index_esm/* CgClose */.Fk5, {})
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
        dividers: true,
        sx: {
          padding: "0",
          minHeight: "50vh",
          maxHeight: "50vh"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (list_module_default()).search_input_modal,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            autoFocus: true,
            onChange: function onChange(e) {
              getUserList(e.target.value);
            },
            type: "text",
            placeholder: "Search User"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiSearch */.jRj, {
            className: (list_module_default()).search_icon,
            style: {
              fontSize: "20px"
            }
          })]
        }), userList && (userList === null || userList === void 0 ? void 0 : userList.length) > 0 && !loading && (userList === null || userList === void 0 ? void 0 : userList.map(function (item, i) {
          var _item$fullName;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            onClick: function onClick() {
              setActiveProfile(item);
            },
            className: activeProfile && activeProfile.email === item.email ? (list_module_default()).active_chatt_box_modal : (list_module_default()).chatt_box,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (list_module_default()).chatt,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).image_wrapper,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  src: item.mediaSrc ? item.mediaSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
                  alt: (_item$fullName = item.fullName) !== null && _item$fullName !== void 0 ? _item$fullName : ""
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (list_module_default()).chatt_msg,
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [(item === null || item === void 0 ? void 0 : item.fullName) && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    style: {
                      textTransform: "capitalize"
                    },
                    children: item === null || item === void 0 ? void 0 : item.fullName
                  }), (item === null || item === void 0 ? void 0 : item.email) && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    children: [item === null || item === void 0 ? void 0 : item.email, " (", item === null || item === void 0 ? void 0 : item.userTypeSlug, ")"]
                  })]
                })
              })]
            })
          }, "plist_".concat(i));
        })), loading && Array(6).fill().map(function (item, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
            sx: {
              maxWidth: "100%",
              padding: "0 15px",
              margin: "-16px 0",
              boxShadow: "none"
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
              avatar: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                variant: "circular",
                width: 40,
                height: 40
              }),
              title: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "80%",
                style: {
                  marginBottom: 6
                }
              }),
              subheader: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.Z, {
                animation: "wave",
                height: 10,
                width: "40%"
              })
            })
          }, i);
        }), (userList === null || userList === void 0 ? void 0 : userList.length) === 0 && !loading && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (list_module_default()).no_found,
          children: "No User Found"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
        sx: {
          padding: "12px 20px"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          className: "btn btn-cancel btn-md",
          onClick: handleClose,
          children: "Cancel"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: function onClick() {
            return handleSubmit(activeProfile);
          },
          type: "submit",
          className: "btn btn-secondary btn-md",
          style: {
            minWidth: "82px"
          },
          children: "Add"
        })]
      })]
    })]
  });
};
/* harmony default export */ var person_list = ((/* unused pure expression or super */ null && (PersonList)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(44731);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/tfi/index.esm.js
var tfi_index_esm = __webpack_require__(81873);
// EXTERNAL MODULE: ./node_modules/react-scroll-to-bottom/lib/esm/index.js + 56 modules
var esm = __webpack_require__(17352);
// EXTERNAL MODULE: ./_unisearch/common/chatbox/message_component/message.module.scss
var message_module = __webpack_require__(42891);
var message_module_default = /*#__PURE__*/__webpack_require__.n(message_module);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/message_component/index.jsx




/* eslint-disable @next/next/no-img-element */













var MessageComponent = function MessageComponent(_ref) {
  var _messages$, _connectedUserList$fi6, _connectedUserList$fi7, _myMessages$replace;

  var profileInfo = _ref.profileInfo,
      messages = _ref.messages,
      setMessages = _ref.setMessages,
      scrolref = _ref.scrolref,
      _ref$currentChat = _ref.currentChat,
      currentChat = _ref$currentChat === void 0 ? (_messages$ = messages[0]) === null || _messages$ === void 0 ? void 0 : _messages$.receiver : _ref$currentChat,
      getConnectedUserList = _ref.getConnectedUserList,
      _ref$connectedUserLis = _ref.connectedUserList,
      connectedUserList = _ref$connectedUserLis === void 0 ? false : _ref$connectedUserLis,
      chatId = _ref.chatId,
      socket = _ref.socket,
      setArrivalMessage = _ref.setArrivalMessage,
      closeDrawer = _ref.closeDrawer,
      openDrawer = _ref.openDrawer;

  //message state
  var _useState = (0,react.useState)(""),
      myMessages = _useState[0],
      setMyMessages = _useState[1];

  var _useState2 = (0,react.useState)(""),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var addNewLineToTextArea = function addNewLineToTextArea() {
    var msg_text = myMessages + "\r\n";
    setMyMessages(msg_text);
  }; //when press enter send message


  var handleKeyPress = function handleKeyPress(e) {
    var _e$target$value, _e$target$value$repla;

    if (e.keyCode === 13 && e.shiftKey) {
      e.preventDefault();
      addNewLineToTextArea();
    } else if (e.keyCode === 13 && ((_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : (_e$target$value$repla = _e$target$value.replace(/\s/g, "")) === null || _e$target$value$repla === void 0 ? void 0 : _e$target$value$repla.length) >= 1 && !loading) {
      handleSubmitMessage();
    }
  }; // push new message


  var handleSubmitMessage = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var _connectedUserList$fi, _connectedUserList$fi2;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              _context2.next = 3;
              return api/* default.post */.Z.post("/chat-service/new-meessage", {
                uid: chatId,
                messages: myMessages,
                recieverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi = connectedUserList.find(function (item) {
                  return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                })) === null || _connectedUserList$fi === void 0 ? void 0 : (_connectedUserList$fi2 = _connectedUserList$fi.receiver) === null || _connectedUserList$fi2 === void 0 ? void 0 : _connectedUserList$fi2.id,
                recieverType: "university",
                senderTime: new Date()
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(res) {
                  var _connectedUserList$fi3, _connectedUserList$fi4, _connectedUserList$fi5;

                  return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.error) {
                            setMyMessages("");
                            getConnectedUserList();
                            setMessages(function (prev) {
                              var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7, _res$data8, _res$data9, _res$data10, _res$data11, _res$data12;

                              return [].concat((0,toConsumableArray/* default */.Z)(prev), [{
                                id: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.id,
                                uid: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.uid,
                                studentId: (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.studentId,
                                senderType: (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.senderType,
                                universityId: (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.universityId,
                                university: (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.university,
                                mentorId: (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.mentorId,
                                mentor: (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.mentor,
                                recieverType: (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.recieverType,
                                messages: (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.messages,
                                createdAt: (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.createdAt,
                                senderTime: res === null || res === void 0 ? void 0 : (_res$data12 = res.data) === null || _res$data12 === void 0 ? void 0 : _res$data12.senderTime
                              }]);
                            });
                            setArrivalMessage(null);
                            socket.current.emit("send-message", {
                              senderId: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id,
                              receiverId: connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi3 = connectedUserList.find(function (item) {
                                return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
                              })) === null || _connectedUserList$fi3 === void 0 ? void 0 : (_connectedUserList$fi4 = _connectedUserList$fi3.receiver) === null || _connectedUserList$fi4 === void 0 ? void 0 : (_connectedUserList$fi5 = _connectedUserList$fi4.id) === null || _connectedUserList$fi5 === void 0 ? void 0 : _connectedUserList$fi5.toString(),
                              text: myMessages,
                              senderTime: new Date()
                            });
                            setLoading(false);
                          } else {
                            setLoading(false);
                          }

                        case 1:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmitMessage() {
      return _ref2.apply(this, arguments);
    };
  }(); // rendar message


  var RenderMessage = function RenderMessage(msgData) {
    var _msgData$receiver, _msgData$receiver2, _msgData$receiver3;

    if ((msgData === null || msgData === void 0 ? void 0 : msgData.is_first) == 1) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "chat_time",
        style: {
          fontSize: "13px"
        },
        children: msgData === null || msgData === void 0 ? void 0 : msgData.messages
      });
    } else if (msgData && (msgData === null || msgData === void 0 ? void 0 : msgData.studentId) === (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id) && (msgData === null || msgData === void 0 ? void 0 : msgData.senderType) === "student") {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).my_msg_wrapper,
        children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (message_module_default()).my_msg_time,
          children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).my_msg,
          children: [(0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages), (msgData === null || msgData === void 0 ? void 0 : msgData.is_read) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(io5_index_esm/* IoCheckmarkDoneOutline */.xOC, {
            className: (message_module_default()).mark
          })]
        })]
      });
    }

    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).buddy_msg_wrapper,
      children: [(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (message_module_default()).msg_time,
        children: [moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).fromNow(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: moment_default()(msgData === null || msgData === void 0 ? void 0 : msgData.senderTime).format("hh:mm A")
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).msg_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).image_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            style: (msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver = msgData.receiver) === null || _msgData$receiver === void 0 ? void 0 : _msgData$receiver.userTypeSlug) === "university" ? {
              objectFit: "contain"
            } : {},
            src: msgData !== null && msgData !== void 0 && (_msgData$receiver2 = msgData.receiver) !== null && _msgData$receiver2 !== void 0 && _msgData$receiver2.media ? msgData === null || msgData === void 0 ? void 0 : (_msgData$receiver3 = msgData.receiver) === null || _msgData$receiver3 === void 0 ? void 0 : _msgData$receiver3.media : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png"),
            alt: "avatar"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).replymsg,
          children: (0,helpers/* newLineText */.$m)(msgData === null || msgData === void 0 ? void 0 : msgData.messages)
        })]
      })]
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (message_module_default()).message_component_wrapper,
    children: [currentChat && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (message_module_default()).heading,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(tfi_index_esm/* TfiMenu */.lrj, {
        className: (message_module_default()).heading_menu,
        onClick: openDrawer
      }), connectedUserList === null || connectedUserList === void 0 ? void 0 : (_connectedUserList$fi6 = connectedUserList.find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.uid) == chatId;
      })) === null || _connectedUserList$fi6 === void 0 ? void 0 : (_connectedUserList$fi7 = _connectedUserList$fi6.receiver) === null || _connectedUserList$fi7 === void 0 ? void 0 : _connectedUserList$fi7.name]
    }), messages && currentChat ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.ZP, {
        className: (message_module_default()).conversation_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (message_module_default()).conversation_wrapper_child,
          children: messages && (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && (messages === null || messages === void 0 ? void 0 : messages.map(function (msgData, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "chat_scroll",
              id: "chat_scroll",
              children: RenderMessage(msgData)
            }, (Math.random() + 1).toString(36).substring(7));
          }))
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (message_module_default()).msg_footer_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (message_module_default()).action,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (message_module_default()).left,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (message_module_default()).image_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                alt: "profile",
                src: profileInfo !== null && profileInfo !== void 0 && profileInfo.profileImageSrc ? profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.profileImageSrc : (0,helpers/* getAssets */.Vh)("assets/student-avatar-big.png")
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
              "aria-label": "minimum height",
              style: {
                minHeight: "40px"
              },
              placeholder: "Reply Message...",
              value: myMessages !== null && myMessages !== void 0 ? myMessages : "",
              onChange: function onChange(e) {
                setMyMessages(e.target.value);
              },
              onKeyDown: function onKeyDown(e) {
                if (e.key === "Enter") {
                  e.preventDefault();
                }

                handleKeyPress(e);
              }
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (message_module_default()).action_btn,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(IconButton_IconButton/* default */.Z, {
              disabled: (myMessages === null || myMessages === void 0 ? void 0 : (_myMessages$replace = myMessages.replace(/\s/g, "")) === null || _myMessages$replace === void 0 ? void 0 : _myMessages$replace.length) >= 1 ? false : true,
              onClick: handleSubmitMessage,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdSend */.D6S, {})
            })
          })]
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (message_module_default()).details_wrapper2,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (message_module_default()).empty_detail_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: "Select a chat or start a new conversation"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          onClick: openDrawer,
          className: "btn btn-outline-grey btn-sm",
          children: "Start"
        })]
      })
    })]
  });
};
/* harmony default export */ var message_component = ((/* unused pure expression or super */ null && (MessageComponent)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/person_profile/index.jsx




var person_profile_excluded = (/* unused pure expression or super */ null && (["data", "profileType"]));


function person_profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function person_profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? person_profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : person_profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, (_objectSpread2 = {
      minHeight: "46px",
      boxShadow: state.isFocused ? "none" : "none",
      borderColor: "none",
      "&:hover": {
        borderColor: "none"
      }
    }, (0,defineProperty/* default */.Z)(_objectSpread2, "borderColor", state.isFocused ? "#f5f8fa" : "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "backgroundColor", "#f5f8fa"), (0,defineProperty/* default */.Z)(_objectSpread2, "fontSize", "14px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return person_profile_objectSpread(person_profile_objectSpread({}, provided), {}, {
      cursor: "pointer",
      fontSize: "14px",
      transition: "all 0.3s",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuList: function menuList(base) {
    return person_profile_objectSpread(person_profile_objectSpread({}, base), {}, {
      "::-webkit-scrollbar": {
        width: "5px",
        height: "6px",
        overflow: "visible",
        cursor: "pointer",
        background: "transparent",
        borderRadius: "10px"
      },
      "::-webkit-scrollbar-thumb": {
        background: "rgb(202, 202, 202)",
        borderRadius: "10px",
        cursor: "pointer"
      }
    });
  }
};
var PersonProfile = function PersonProfile(_ref) {
  var _data$name, _profileInfo$workingC, _profileInfo$preferen, _profileInfo$preferen2, _profileInfo$preferen3, _profileInfo$preferen4, _profileInfo$preferen5, _profileInfo$preferen6, _profileInfo$preferen7, _profileInfo$preferen8, _profileInfo$preferen9, _profileInfo$preferen10, _profileInfo$preferen11, _profileInfo$preferen12, _profileInfo$preferen13, _profileInfo$preferen14, _profileInfo$preferen15, _profileInfo$preferen16, _profileInfo$preferen17, _profileInfo$preferen18, _profileInfo$preferen19, _profileInfo$preferen20, _profileInfo$preferen21, _profileInfo$preferen22, _profileInfo$preferen23, _profileInfo$preferen24, _profileInfo$preferen25, _profileInfo$preferen26, _profileInfo$preferen27, _profileInfo$preferen28, _profileInfo$preferen29, _profileInfo$preferen30, _profileInfo$preferen31, _profileInfo$preferen32, _profileInfo$preferen33, _profileInfo$preferen34, _profileInfo$preferen35, _profileInfo$preferen36, _profileInfo$preferen37, _profileInfo$preferen38;

  var data = _ref.data,
      profileType = _ref.profileType,
      props = _objectWithoutProperties(_ref, person_profile_excluded);

  var tZone = getTimeZone();

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _useState = useState(moment.tz.guess()),
      currentTzone = _useState[0],
      setCurrentTzone = _useState[1];

  var _useState2 = useState(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(false),
      showInMobile = _useState3[0],
      setShowInMobile = _useState3[1];

  var _useState4 = useState(),
      timeSlot = _useState4[0],
      setTimeslot = _useState4[1];

  var _useState5 = useState({}),
      profileInfo = _useState5[0],
      setProfileInfo = _useState5[1];

  var _useState6 = useState(),
      index = _useState6[0],
      setIndex = _useState6[1];

  var getProfile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/user/any-profile?userType=".concat(profileType, "&id=").concat(data === null || data === void 0 ? void 0 : data.id)).then(function (res) {
                if (!res.error) {
                  setProfileInfo(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getProfile() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && profileType) {
      getProfile();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, profileType]);

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var payload;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              payload = {
                date: value,
                counsellorId: data === null || data === void 0 ? void 0 : data.id,
                timezone: currentTzone
              };
              _context2.next = 3;
              return API.post("/student/counsellor-appointment/time-list", payload).then(function (res) {
                if (!res.error) {
                  setTimeslot(res.data);
                }
              })["catch"](function (error) {
                swalError("Something went wrong");
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSubmit() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (data !== null && data !== void 0 && data.id && value && currentTzone && profileType === "counsellor") {
      handleSubmit();
    }
  }, [data === null || data === void 0 ? void 0 : data.id, value, currentTzone, profileType]);

  function formatAMPM(time) {
    // return time;
    var hour = time.split(":");
    var hrs = parseInt(hour[0]);
    var ampm = hrs >= 12 ? "pm" : "am";
    hrs = hrs % 12;
    hrs = hrs ? hrs : 12; // the hour '0' should be '12'

    var strTime = hrs + ":" + hour[1] + " " + ampm;
    return strTime;
  }

  var handleOpen = function handleOpen() {
    setOpen(true);
    document.body.classList.add("popOpen");
    handleSubmit();
  };

  var handleClose = function handleClose() {
    setOpen(false);
    document.body.classList.remove("popOpen");
    setIndex();
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.profile_wrapper,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.image_wrapper,
      children: /*#__PURE__*/_jsx("img", {
        src: data.profileImage ? data.profileImage : getAssets("assets/student-avatar-big.png"),
        alt: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : ""
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: data.name
    }), profileType && profileType == "counsellor" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.profile_bio,
        children: [profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && htmlParse(profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio), profileInfo && (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.bio) && /*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/student/counsellor/".concat(data === null || data === void 0 ? void 0 : data.id),
          children: /*#__PURE__*/_jsx("a", {
            className: styles.read_more,
            children: "Read More"
          })
        })]
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && /*#__PURE__*/_jsx("h5", {
        children: "Working Country"
      }), (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.workingCountry) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$workingC = profileInfo.workingCountry) === null || _profileInfo$workingC === void 0 ? void 0 : _profileInfo$workingC.length) > 0 && /*#__PURE__*/_jsx("div", {
        className: styles.country_wrapper,
        children: profileInfo.workingCountry && profileInfo.workingCountry.map(function (item, i) {
          return /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: item
          }, i);
        })
      }), /*#__PURE__*/_jsx("button", {
        onClick: handleOpen,
        className: "btn btn-primary ".concat(styles.book_appiontment),
        children: "Book Appointment"
      })]
    }), profileType && profileType == "student" && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen = profileInfo.preferences) === null || _profileInfo$preferen === void 0 ? void 0 : _profileInfo$preferen.courselevel) && /*#__PURE__*/_jsx("h5", {
          children: "Course Level"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen2 = profileInfo.preferences) === null || _profileInfo$preferen2 === void 0 ? void 0 : (_profileInfo$preferen3 = _profileInfo$preferen2.courselevel) === null || _profileInfo$preferen3 === void 0 ? void 0 : _profileInfo$preferen3.levelName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen4 = profileInfo.preferences) === null || _profileInfo$preferen4 === void 0 ? void 0 : (_profileInfo$preferen5 = _profileInfo$preferen4.courselevel) === null || _profileInfo$preferen5 === void 0 ? void 0 : _profileInfo$preferen5.levelName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen6 = profileInfo.preferences) === null || _profileInfo$preferen6 === void 0 ? void 0 : _profileInfo$preferen6.countryPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Country Preferences"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen7 = profileInfo.preferences) === null || _profileInfo$preferen7 === void 0 ? void 0 : _profileInfo$preferen7.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen8 = profileInfo.preferences) === null || _profileInfo$preferen8 === void 0 ? void 0 : (_profileInfo$preferen9 = _profileInfo$preferen8.countryPreferences) === null || _profileInfo$preferen9 === void 0 ? void 0 : _profileInfo$preferen9.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen10 = profileInfo.preferences) === null || _profileInfo$preferen10 === void 0 ? void 0 : _profileInfo$preferen10.countryPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen11 = profileInfo.preferences) === null || _profileInfo$preferen11 === void 0 ? void 0 : (_profileInfo$preferen12 = _profileInfo$preferen11.countryPreferences) === null || _profileInfo$preferen12 === void 0 ? void 0 : _profileInfo$preferen12.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen13 = profileInfo.preferences) === null || _profileInfo$preferen13 === void 0 ? void 0 : _profileInfo$preferen13.studyPreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Preferred Courses"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen14 = profileInfo.preferences) === null || _profileInfo$preferen14 === void 0 ? void 0 : _profileInfo$preferen14.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen15 = profileInfo.preferences) === null || _profileInfo$preferen15 === void 0 ? void 0 : (_profileInfo$preferen16 = _profileInfo$preferen15.studyPreferences) === null || _profileInfo$preferen16 === void 0 ? void 0 : _profileInfo$preferen16.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen17 = profileInfo.preferences) === null || _profileInfo$preferen17 === void 0 ? void 0 : _profileInfo$preferen17.studyPreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen18 = profileInfo.preferences) === null || _profileInfo$preferen18 === void 0 ? void 0 : (_profileInfo$preferen19 = _profileInfo$preferen18.studyPreferences) === null || _profileInfo$preferen19 === void 0 ? void 0 : _profileInfo$preferen19.map(function (item, i) {
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: item
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen20 = profileInfo.preferences) === null || _profileInfo$preferen20 === void 0 ? void 0 : _profileInfo$preferen20.specialization) && /*#__PURE__*/_jsx("h5", {
          children: "Specialization"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen21 = profileInfo.preferences) === null || _profileInfo$preferen21 === void 0 ? void 0 : (_profileInfo$preferen22 = _profileInfo$preferen21.specialization) === null || _profileInfo$preferen22 === void 0 ? void 0 : _profileInfo$preferen22.specializationName) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen23 = profileInfo.preferences) === null || _profileInfo$preferen23 === void 0 ? void 0 : (_profileInfo$preferen24 = _profileInfo$preferen23.specialization) === null || _profileInfo$preferen24 === void 0 ? void 0 : _profileInfo$preferen24.specializationName
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen25 = profileInfo.preferences) === null || _profileInfo$preferen25 === void 0 ? void 0 : _profileInfo$preferen25.intakePreferences) && /*#__PURE__*/_jsx("h5", {
          children: "Intake"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen26 = profileInfo.preferences) === null || _profileInfo$preferen26 === void 0 ? void 0 : _profileInfo$preferen26.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen27 = profileInfo.preferences) === null || _profileInfo$preferen27 === void 0 ? void 0 : (_profileInfo$preferen28 = _profileInfo$preferen27.intakePreferences) === null || _profileInfo$preferen28 === void 0 ? void 0 : _profileInfo$preferen28.length) > 0 && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen29 = profileInfo.preferences) === null || _profileInfo$preferen29 === void 0 ? void 0 : _profileInfo$preferen29.intakePreferences) && (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen30 = profileInfo.preferences) === null || _profileInfo$preferen30 === void 0 ? void 0 : (_profileInfo$preferen31 = _profileInfo$preferen30.intakePreferences) === null || _profileInfo$preferen31 === void 0 ? void 0 : _profileInfo$preferen31.map(function (item, i) {
            var year = item.year,
                data = item.data;
            var last = Object.keys(data).length - 1;
            var payload = {
              year: year,
              from: data[Object.keys(data)[0]],
              to: data[Object.keys(data)[last]]
            };
            return /*#__PURE__*/_jsx("h6", {
              className: styles.country,
              children: "".concat(payload.from, "-").concat(payload.to, ", ").concat(payload.year)
            }, i);
          }))
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen32 = profileInfo.preferences) === null || _profileInfo$preferen32 === void 0 ? void 0 : _profileInfo$preferen32.budget) && /*#__PURE__*/_jsx("h5", {
          children: "Budget"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen33 = profileInfo.preferences) === null || _profileInfo$preferen33 === void 0 ? void 0 : _profileInfo$preferen33.budget) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen34 = profileInfo.preferences) === null || _profileInfo$preferen34 === void 0 ? void 0 : _profileInfo$preferen34.budget
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        style: {
          margin: "25px 0"
        },
        children: [(profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen35 = profileInfo.preferences) === null || _profileInfo$preferen35 === void 0 ? void 0 : _profileInfo$preferen35.objective) && /*#__PURE__*/_jsx("h5", {
          children: "Objective"
        }), (profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen36 = profileInfo.preferences) === null || _profileInfo$preferen36 === void 0 ? void 0 : _profileInfo$preferen36.objective) && /*#__PURE__*/_jsx("div", {
          className: styles.country_wrapper,
          children: /*#__PURE__*/_jsx("h6", {
            className: styles.country,
            children: profileInfo === null || profileInfo === void 0 ? void 0 : (_profileInfo$preferen37 = profileInfo.preferences) === null || _profileInfo$preferen37 === void 0 ? void 0 : (_profileInfo$preferen38 = _profileInfo$preferen37.objective) === null || _profileInfo$preferen38 === void 0 ? void 0 : _profileInfo$preferen38.objectivePurpose
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      closeAfterTransition: true,
      BackdropComponent: Backdrop,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/_jsxs("div", {
        className: "modal ".concat(styles.modal_custom_width),
        children: [/*#__PURE__*/_jsx("button", {
          className: "".concat(styles.cross_icon, " cross_icon"),
          onClick: handleClose,
          children: /*#__PURE__*/_jsx(FiX, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.appoint_modal,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.appoint_modal_right,
            children: [/*#__PURE__*/_jsx("h3", {
              className: styles.appoint_title,
              children: "Select a Date & Time"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.appoint_calender_and_time_wrapper,
              children: [/*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.calender_and_time_zone_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsx("div", {
                  style: {
                    maxHeight: "310px"
                  },
                  children: /*#__PURE__*/_jsx(LocalizationProvider, {
                    dateAdapter: AdapterDateFns,
                    children: /*#__PURE__*/_jsx(StaticDatePicker, {
                      className: "appointModalDatePicker",
                      displayStaticWrapperAs: "desktop",
                      openTo: "day",
                      minDate: new Date(),
                      value: value,
                      onChange: function onChange(newValue) {
                        setValue(newValue);
                        setShowInMobile(true);
                        setIndex();
                      },
                      renderInput: function renderInput(params) {
                        return /*#__PURE__*/_jsx(TextField, person_profile_objectSpread({}, params));
                      }
                    })
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.time_zone_wrapper,
                  children: [/*#__PURE__*/_jsx("label", {
                    className: styles.label,
                    children: "Select Time Zone"
                  }), /*#__PURE__*/_jsx(Select, {
                    menuPlacement: "top",
                    placeholder: "Select Timezone",
                    styles: customStyles,
                    options: tZone,
                    value: currentTzone && tZone ? tZone.filter(function (tz) {
                      return tz.value == currentTzone;
                    }) : "",
                    onChange: function onChange(item) {
                      setCurrentTzone(item.value);
                      setIndex();
                    }
                  })]
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: "".concat(styles.appoint_time_wrapper, " ").concat(showInMobile ? styles.active : ""),
                children: [/*#__PURE__*/_jsxs("div", {
                  className: styles.back_icon_and_date_wrapper,
                  children: [/*#__PURE__*/_jsx(IconButton, {
                    onClick: function onClick() {
                      return setShowInMobile(false);
                    },
                    className: styles.back_btn,
                    children: /*#__PURE__*/_jsx(ArrowBackIcon, {})
                  }), /*#__PURE__*/_jsx("div", {
                    className: styles.appoint_time_title,
                    children: new Date(value).toDateString()
                  })]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.appoint_time_list_wrapper,
                  children: /*#__PURE__*/_jsx("ul", {
                    children: timeSlot && timeSlot.length > 0 ? timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.map(function (item, i) {
                      return /*#__PURE__*/_jsxs("li", {
                        children: [/*#__PURE__*/_jsxs("button", {
                          onClick: function onClick() {
                            return setIndex(i);
                          },
                          className: "".concat(styles.appoint_time_btn, " ").concat(index === i ? styles.active : ""),
                          children: [formatAMPM(item === null || item === void 0 ? void 0 : item.startTime), "-", formatAMPM(item === null || item === void 0 ? void 0 : item.endTime)]
                        }), /*#__PURE__*/_jsx("button", {
                          className: "".concat(styles.confirm_btn, " ").concat(index === i ? styles.active : "", " btn btn-secondary btn-bg"),
                          onClick: function onClick() {
                            handleFormSubmit(item === null || item === void 0 ? void 0 : item.timeId);
                          },
                          children: "Confirm"
                        })]
                      }, i);
                    }) : /*#__PURE__*/_jsx("li", {
                      className: styles.no_record,
                      children: "\"No Appoinment Schedule\""
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var person_profile = ((/* unused pure expression or super */ null && (PersonProfile)));
;// CONCATENATED MODULE: ./_unisearch/common/chatbox/index.js



// EXTERNAL MODULE: ./_unisearch/common/form/index.js + 15 modules
var common_form = __webpack_require__(15603);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(93162);
;// CONCATENATED MODULE: ./_unisearch/common/download_guide/index.jsx


var download_guide_excluded = ["fileSrc", "btnTitle", "fileName", "documentType", "customClasses", "customStyles", "universityId", "documentId"];











/*
documentType -> 'prospectus', 'exam', 'document', 'course', 'ebook', 'countryguide'

This componetn takes props
-> fileSrc
-> fileName
-> btnTitle
-> documentType
-> universityId
-> documentId
-> customClasses={
        root.[your class name]
    }
-> customClasses={
        title.[your class name]
   }
-> customClasses={
        tooltip.[your class name]
    }
-> customStyles={{ root: { color: "blue" } }}
-> customStyles={{ title: { fontSize: "30px" } }}
-> customStyles={{ tooltip: { color: "blue" } }}
 */



var DownloadGuide = function DownloadGuide(_ref) {
  var fileSrc = _ref.fileSrc,
      btnTitle = _ref.btnTitle,
      fileName = _ref.fileName,
      _ref$documentType = _ref.documentType,
      documentType = _ref$documentType === void 0 ? "prospectus" : _ref$documentType,
      customClasses = _ref.customClasses,
      customStyles = _ref.customStyles,
      _ref$universityId = _ref.universityId,
      universityId = _ref$universityId === void 0 ? 0 : _ref$universityId,
      _ref$documentId = _ref.documentId,
      documentId = _ref$documentId === void 0 ? 0 : _ref$documentId,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, download_guide_excluded);

  var router = (0,next_router.useRouter)();
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var profileInfos = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(profileInfos);
  }, []);

  var storeStudentDownloadInfo = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return api/* default.post */.Z.post("/student/download-activity", {
                universityId: universityId,
                type: documentType,
                mediaId: documentId
              }).then(function (res) {});

            case 3:
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](0);
              (0,helpers/* swalError */.Kj)("Something went wrong");

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 5]]);
    }));

    return function storeStudentDownloadInfo() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleDownload = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(fileSrc) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (profileInfo) {
                _context2.next = 3;
                break;
              }

              systemActions.setReturnUrl(router.asPath);
              return _context2.abrupt("return", router.push({
                pathname: "/signin"
              }));

            case 3:
              if (profileInfo && profileInfo.userTypeSlug === "student") {
                storeStudentDownloadInfo();
              }

              window.open(fileSrc, "_blank");

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleDownload(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
    onClick: function onClick() {
      handleDownload(fileSrc);
    },
    className: "btn btn-secondary relative ".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.root,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPictureAsPdf */.OY_, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.title ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.title : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.title,
      children: btnTitle || "Download Brochure"
    }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "uni-tooltip ".concat(customClasses !== null && customClasses !== void 0 && customClasses.tooltip ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.tooltip : ""),
      style: customStyles === null || customStyles === void 0 ? void 0 : customStyles.tooltip,
      children: ["Please Login ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " to perform this action"]
    })]
  });
};
/* harmony default export */ var download_guide = ((/* unused pure expression or super */ null && (DownloadGuide)));
;// CONCATENATED MODULE: ./_unisearch/common/index.js





/***/ }),

/***/ 1692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BookmarkAction": function() { return /* binding */ BookmarkAction; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72145);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89583);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2804);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(53990);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);















var BookmarkAction = function BookmarkAction(_ref) {
  var customClasses = _ref.customClasses,
      referance = _ref.referance,
      referanceId = _ref.referanceId,
      is_bookmarked = _ref.is_bookmarked,
      _ref$showText = _ref.showText,
      showText = _ref$showText === void 0 ? true : _ref$showText,
      _ref$getReadingList = _ref.getReadingList,
      getReadingList = _ref$getReadingList === void 0 ? false : _ref$getReadingList;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useAuthActions */ .X$)();
  var profileInfos = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4); //referanceItems =  (blog,page )

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, [systemActions]);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (profileInfos) {
      setProfileInfo(profileInfos);
    }
  }, []); //Handle Bookmarke

  var handleBookmark = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context2.next = 7;
                break;
              }

              setIsLoading(true);
              payload = {
                readingType: referance,
                referenceId: referanceId
              };
              _context2.next = 5;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/student/reading-list", payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context.next = 7;
                            break;
                          }

                          _context.next = 3;
                          return authActions.getProfile();

                        case 3:
                          setIsLoading(false);
                          if (getReadingList) getReadingList();
                          _context.next = 9;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 5:
              _context2.next = 10;
              break;

            case 7:
              systemActions.setReturnUrl(router.asPath);
              _context2.next = 10;
              return router.push({
                pathname: "/signin"
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleBookmark() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.Fragment, {
    children: is_bookmarked ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
      className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(is_bookmarked ? (_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active) : "", " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaBookmark */ .VF9, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark)),
          style: {
            color: "#f47f20"
          }
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Bookmarked"
        })]
      })
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
      className: "relative ".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().bookmarke_wrapper), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("button", {
        className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().btn_bookmark), " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.btnClass ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.btnClass : ""),
        onClick: function onClick() {
          return handleBookmark();
        },
        children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_11__/* .FaRegBookmark */ .mCg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().reg_bookmark))
        }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_12__/* .ImSpinner8 */ .IDg, {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon_spin))
        }), showText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("span", {
          children: "Add to Bookmark"
        })]
      }), (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_1__/* .isEmpty */ .xb)(profileInfo) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        className: "uni-tooltip",
        children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
      })]
    })
  });
};
/* harmony default export */ __webpack_exports__["default"] = (BookmarkAction);

/***/ }),

/***/ 74292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27991);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81496);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);






var BlogUpdate = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 8281).then(__webpack_require__.bind(__webpack_require__, 28281));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28281)];
    }
  }
});
var ScrollPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 5710).then(__webpack_require__.bind(__webpack_require__, 25710));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25710)];
    }
  }
});

var CountryPage = function CountryPage(_ref) {
  var _pageData$featureImag;

  var pageData = _ref.pageData,
      country_name = _ref.country_name,
      country_page_slug = _ref.country_page_slug,
      countryData = _ref.countryData;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_3__/* .LayoutMain */ .Ku, {
      isLeadPopup: true,
      footer_with_evaluation: true,
      title: pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle,
      metaTitle: (pageData === null || pageData === void 0 ? void 0 : pageData.metaTitle) || (pageData === null || pageData === void 0 ? void 0 : pageData.pageTitle),
      metaKeywords: (pageData === null || pageData === void 0 ? void 0 : pageData.metaKeyword) || "unisearch, study",
      metaDescription: pageData === null || pageData === void 0 ? void 0 : pageData.metaDescription,
      metaImage: pageData === null || pageData === void 0 ? void 0 : (_pageData$featureImag = pageData.featureImage) === null || _pageData$featureImag === void 0 ? void 0 : _pageData$featureImag.src,
      metaUrl: "".concat("https://myunisearch.com", "/study/").concat(country_name, "/").concat(country_page_slug),
      children: [pageData && pageData !== null && pageData !== void 0 && pageData.videoType ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__/* .StudyBannerTwo */ .T$, {
        pageData: pageData,
        name: country_name,
        linkType: "study"
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__/* .StudyBanner */ .hk, {
        pageData: pageData,
        name: country_name,
        linkType: "study"
      }), ((pageData === null || pageData === void 0 ? void 0 : pageData.videoupload) !== null || (pageData === null || pageData === void 0 ? void 0 : pageData.embedCode) !== "") && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__/* .StudyVideo */ .mp, {
        countryData: countryData,
        pageData: pageData
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__/* .StudyLinks */ .aF, {
        linkType: "study",
        name: country_name,
        pageData: pageData
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_modules_study_country_study_why_country__WEBPACK_IMPORTED_MODULE_2__/* .StudyWhyCountryIntro */ .dq, {
        linkType: "study",
        name: country_name,
        pageData: pageData
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(BlogUpdate, {})]
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CountryPage);

/***/ }),

/***/ 75999:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study/[country_name]/[country_page_slug]",
      function () {
        return __webpack_require__(74292);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"page_info___next__KpAYC","short_info":"page_info_short_info__2CVJV","info_item":"page_info_info_item__PvuOa","icon":"page_info_icon__TsLci","author":"page_info_author__pq2Y3","text":"page_info_text__cqeYo","name":"page_info_name__tcb28","desc":"page_info_desc__aF06O"};

/***/ }),

/***/ 30890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"play_btn":"play_btn_with_ripple_play_btn__yNA0_","arrow_right":"play_btn_with_ripple_arrow_right__Fmzao","ripple_effect":"play_btn_with_ripple_ripple_effect__4Jxcn","ModalRipple":"play_btn_with_ripple_ModalRipple__5yAi9","medium":"play_btn_with_ripple_medium__ClXl0","small":"play_btn_with_ripple_small__EszEQ","orange":"play_btn_with_ripple_orange__1q96e"};

/***/ }),

/***/ 76300:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"social_links_wrapper":"social_links_social_links_wrapper__k2gOD"};

/***/ }),

/***/ 58982:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_banner___next__WYVpN","section_study_banner":"study_banner_section_study_banner__iWl7l","hero_wrapper":"study_banner_hero_wrapper__xtqP_","hero_content":"study_banner_hero_content__Pa6kW","heading":"study_banner_heading__5rMcY","description":"study_banner_description__0Nxbe","sub_heading":"study_banner_sub_heading__AwPLq","breadcrumbs":"study_banner_breadcrumbs___KbvC","active":"study_banner_active__a2RHq","image_wrapper":"study_banner_image_wrapper__B_dfe","featured_image":"study_banner_featured_image__NoBka","bg_soft":"study_banner_bg_soft__q9v8b","oval_square":"study_banner_oval_square__Jhd9F","button_wrapper":"study_banner_button_wrapper__5qP8P","short_info_desktop":"study_banner_short_info_desktop__S59iL","short_info_mobile":"study_banner_short_info_mobile__Ygp3J"};

/***/ }),

/***/ 42817:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_banner_two___next__MKU4X","section_study_banner":"study_banner_two_section_study_banner__R83L5","hero_container":"study_banner_two_hero_container__iOc6t","sub_heading":"study_banner_two_sub_heading__4zqNf","description":"study_banner_two_description__lbHQN","breadcrumbs":"study_banner_two_breadcrumbs__gqSc4","active":"study_banner_two_active___8CoC","short_info":"study_banner_two_short_info__w_iaj","info_item":"study_banner_two_info_item__guaea","author":"study_banner_two_author__hasJp","text":"study_banner_two_text__cl0_A","desc":"study_banner_two_desc__rFoti","info_button":"study_banner_two_info_button__cjdhN","short_info_desktop":"study_banner_two_short_info_desktop__GAUP1","short_info_mobile":"study_banner_two_short_info_mobile__fYh0v","image_wrapper":"study_banner_two_image_wrapper__vV7pl","oval_square":"study_banner_two_oval_square__BUqHF"};

/***/ }),

/***/ 52885:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_links___next__1DkBi","section_links":"study_links_section_links__wc_lm","links_wrapper":"study_links_links_wrapper__tf0wu","links_container":"study_links_links_container__0EBHn","active":"study_links_active__PrSVp","social_link_wrapper":"study_links_social_link_wrapper__ob7b_"};

/***/ }),

/***/ 25850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_study_video":"study_video_section_study_video__9afad","study_video_wrapper":"study_video_study_video_wrapper__67lH7","video_area":"study_video_video_area__Nrsx_","overlay":"study_video_overlay__0uzjM"};

/***/ }),

/***/ 27442:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"study_why_country_intro___next__0_akp","section_intro":"study_why_country_intro_section_intro__6gYAg","intro_container":"study_why_country_intro_intro_container__871Sg","social_wrapper":"study_why_country_intro_social_wrapper__wv_e7","uni_comment":"study_why_country_intro_uni_comment__h9_Ua"};

/***/ }),

/***/ 42891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"message_component_wrapper":"message_message_component_wrapper__1ieyP","buddy_msg_wrapper":"message_buddy_msg_wrapper__DK00E","msg_time":"message_msg_time__pkHde","msg_wrapper":"message_msg_wrapper__bcN0z","image_wrapper":"message_image_wrapper__75POr","replymsg":"message_replymsg__Q1uk8","my_msg_time":"message_my_msg_time__RxJqO","my_msg":"message_my_msg__0MTvI","mark":"message_mark__3uB3z","heading":"message_heading__nN8Pc","details_wrapper":"message_details_wrapper__KVYfo","msg_footer_wrapper":"message_msg_footer_wrapper__S9kxU","action":"message_action__0Olen","left":"message_left__1Zl0o","action_btn":"message_action_btn__l9bDv","conversation_wrapper":"message_conversation_wrapper__YdB1H","conversation_wrapper_child":"message_conversation_wrapper_child__50fY7","details_wrapper2":"message_details_wrapper2__mMBhj","empty_detail_wrapper":"message_empty_detail_wrapper__SuI8J","my_msg_wrapper":"message_my_msg_wrapper__PTorz","heading_menu":"message_heading_menu__Kqe7o"};

/***/ }),

/***/ 6867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"active_chatt_box":"list_active_chatt_box__MbZyB","chatt":"list_chatt__Y9S5q","time":"list_time__brnw_","image_wrapper":"list_image_wrapper__waMIN","active_chatt_box_modal":"list_active_chatt_box_modal___BrsY","chatt_box":"list_chatt_box__GiEyE","chatt_msg":"list_chatt_msg__KF_sP","chatt_box_wrapper":"list_chatt_box_wrapper__4qk6k","list_wrapper":"list_list_wrapper__DX7IH","search_input":"list_search_input__2YMvn","search_icon":"list_search_icon__3ZZ8U","header_wrapper":"list_header_wrapper__elCsP","btn_group":"list_btn_group__POPeU","search_input_modal":"list_search_input_modal___ZcDT","modal_body":"list_modal_body__nHnG8","no_found":"list_no_found__wMd8W","btn_close":"list_btn_close__2T9Vb","btn_add_user":"list_btn_add_user__9cjH4","btn_plus":"list_btn_plus__B7L_4"};

/***/ }),

/***/ 53913:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"favourite_wrapper":"actions_favourite_wrapper__mmZgl","icon_heart":"actions_icon_heart__MtTT3","selected":"actions_selected__bf0TV","icon_swap":"actions_icon_swap__irRwk","compare_wrapper":"actions_compare_wrapper__z_sdX","bookmarke_wrapper":"actions_bookmarke_wrapper__31rzO","btn_bookmark":"actions_btn_bookmark__pq8QI","active":"actions_active__vtMRT","icon_spin":"actions_icon_spin__z5nco","spin":"actions_spin__kUes6","connect_wrapper":"actions_connect_wrapper__ESCJU","reply_box_wrapper":"actions_reply_box_wrapper__AVnAn","reply_box_to":"actions_reply_box_to__rmbnD","reply_box_subject":"actions_reply_box_subject__CBp2A","reply_box_actions":"actions_reply_box_actions__GBlrl","reply_box_action_right":"actions_reply_box_action_right__4oLns"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,3609,260,1086,2884,8719,8322,5824,3480,5551,5260,1818,3063,6665,1496,5603,9774,2888,179], function() { return __webpack_exec__(75999); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);